<script setup lang="ts">
import { COMMON_RESET_PAGE_ON, commonFilterFields, PaginationComponent, useQueryFilter } from '@metapic-apps/shared'

import { useClientsList } from '@/api/clients.api'
import PlusIcon from '@/assets/icons/add-plus.svg?component'
import ClientListItem from '@/components/ClientListItem/ClientListItem.vue'
import { FilterComponent } from '@/components/Filter'
import HeaderComponent from '@/components/Navigation/HeaderComponent.vue'
import { config } from '@/lib/helpers'
import type { FilterType } from '@/lib/types/common.types'
import { useUserStore } from '@/stores/user'
import { BoxComponent, ButtonComponent, FlexComponent, LoadingComponent, PageWrapperComponent } from '@/ui-library'

const userStore = useUserStore()

const { filter, reset } = useQueryFilter<FilterType>(
  {
    page: commonFilterFields.page,
    sortBy: commonFilterFields.sortBy,
    query: commonFilterFields.query,
    advertiserGroup: commonFilterFields.advertiserGroup,
  },
  {
    page: 1,
    sortBy: 'created_at:desc',
    advertiserGroup: {
      id: userStore.user.storeGroupId,
      name: '',
    },
  },
  { resetPageOn: COMMON_RESET_PAGE_ON, cleared: { page: 1, sortBy: 'created_at:desc' } },
)
const sortingItems = [{ label: 'Creation date', value: 'created_at' }]
const { data, isLoading, totalPages, error } = useClientsList(() => ({
  advertiserGroupId: filter.value.advertiserGroup?.id,
  query: filter.value.query,
  sortBy: filter.value.sortBy,
  page: filter.value.page,
}))
</script>
<template>
  <HeaderComponent title="Clients">
    <ButtonComponent variant="secondary" :href="`${config.legacyAdminAppUrl}/#/clients/create`">
      <template #iconLeft>
        <el-icon :size="18">
          <PlusIcon />
        </el-icon>
      </template>
      Create client
    </ButtonComponent>
  </HeaderComponent>
  <PageWrapperComponent>
    <BoxComponent :mb="32">
      <FilterComponent v-model="filter" :sorting-items="sortingItems" show-sorting-selector placeholder="Search clients" @clear="reset" />
    </BoxComponent>
    <BoxComponent v-if="error" :mb="24">
      <el-alert :title="error.message" type="error" />
    </BoxComponent>
    <LoadingComponent v-if="isLoading" :size="64" />
    <FlexComponent v-if="data && !isLoading" direction="column" :gap="16">
      <ClientListItem v-for="client in data" :key="client.id" :client="client" />
    </FlexComponent>
    <BoxComponent v-if="totalPages > 0 && data && data?.length > 0" :pt="32" :pb="32">
      <PaginationComponent v-model:current-page="filter.page" :total-pages="totalPages" />
    </BoxComponent>
  </PageWrapperComponent>
</template>
